import styled from 'styled-components'
import RcCollapse, { Panel } from 'rc-collapse'

export const CustomPanel = styled(Panel)`
  .rc-collapse-header {
    font-size: 17px;
    color: ${props => props.theme.color.black1} !important;
    font-family: ${props => props.theme.font.family.medium};
    justify-content:space-between;
    outline: none !important;
    padding: 0px !important;
    padding-bottom: 25px !important;
    svg {
      order: 2;
    }
  }

  .rc-collapse-content {
    padding: 0px !important;
  }

  .rc-collapse-content-box {
    margin: 0px !important;
    padding-bottom: 25px;
    p {
      font-size: 14px;
      color: ${props => props.theme.color.black1};
      line-height: 24px;
    }
  }
  @media screen and (min-width: 1100px) {
    .rc-collapse-header {
      font-size: 20px;
    }
  }

`

export const CustomCollapse = styled(RcCollapse)`
  border: none !important;
  background: none !important;
  border-bottom: 1px solid #E7E7E7 !important;
  @media screen and (min-width: 1100px) {
    
  }
`
